// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"0f169932","920":"0f169932","952":"b1fae32d"}[chunkId] + ".chunk.css";
};